import { ChecklistAnswers, ChecklistQuestionSpec, GuestSubmitBody } from "@nova/schemas"

export const CHECKLIST_LINKING_FORM: ChecklistQuestionSpec[] = [
    {
        id: "linking-pilot-in-command",
        isRequired: true,
        type: "user-select",
        question: "Who is the Pilot in Command?",
    },
    {
        id: "linking-aircraft",
        isRequired: true,
        type: "aircraft-select",
        question: "Which drone is used?",
    },
]

export const VALID_FOR_HOURS_OPTIONS = [1, 2, 4, 8, 12, 24].map((h) => ({
    label: `${h} hour${h === 1 ? "" : "s"}`,
    value: h,
}))

export const DEFAULT_VALID_FOR_HOURS = 12

export const buildPreemptiveSubmitBody = ({
    answers,
    linkingAnswers,
    validForHours,
    checklistVersion,
}: {
    answers: ChecklistAnswers
    linkingAnswers: ChecklistAnswers
    validForHours: number
    checklistVersion: number
}) => {
    const linking = Object.values(linkingAnswers)
    return {
        answers,
        checklistVersion,
        aircraftId: linking.find((v) => v.type === "aircraft-select")?.answer ?? null,
        pilotInCommandId: linking.find((v) => v.type === "user-select")?.answer ?? null,
        validForHours,
    } satisfies GuestSubmitBody
}
